import type { IErrorResponse } from '@/types/apis/Error';

import React from 'react';
// eslint-disable-next-line import/order
import type {
  FetchNextPageOptions,
  InfiniteQueryObserverResult,
} from '@tanstack/react-query';

const useIntersectionObserver = (
  ref: React.MutableRefObject<HTMLDivElement | null>,
  hasNext: boolean | undefined,
  fetchNext: (
    options?: FetchNextPageOptions
  ) => Promise<InfiniteQueryObserverResult<any, IErrorResponse>>
): void => {
  React.useEffect((): (() => void | undefined) => {
    if (!hasNext) {
      return () => undefined;
    }
    const observer = new IntersectionObserver((entries) =>
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          void fetchNext();
        }
      })
    );
    const el = ref?.current;
    if (!el) {
      return () => undefined;
    }
    observer.observe(el);
    return () => {
      observer.unobserve(el);
    };
  }, [hasNext, fetchNext, ref]);
};
export default useIntersectionObserver;
